import { setStoreLocal, getStoreLocal, removeStoreLocal } from "@/utils/store";
const getDefaultState = () => {
  return {
    tree: getStoreLocal({ name: "tree" }) || "", // token 中解析后用户的所有信息
  };
};
const state = getDefaultState();
const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TREE: (state, tree) => {
    state.tree = tree;
  },
};
const actions = {
  setTree({ commit }, tree) {
    commit("SET_TREE", tree);
    setStoreLocal({ name: "tree", content: tree });
  },
  resetTree({ commit }) {
    commit("RESET_STATE");
  },
  removeTree({ commit }) {
    commit("SET_TREE", "");
    removeStoreLocal({ name: "tree" });
  },
};
const getters = {
  tree: (state) => state.tree,
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
